const GOOGLE_FONTS_LINK_ID = 'checkbuild-google-font';

export function applyTheme(settings) {
  const root = document.documentElement;
  if (settings.hero_colour) root.style.setProperty('--brand-hero', settings.hero_colour);
  if (settings.btn_primary_colour) root.style.setProperty('--brand-primary', settings.btn_primary_colour);
  if (settings.btn_secondary_colour) root.style.setProperty('--brand-secondary', settings.btn_secondary_colour);
  if (settings.btn_danger_colour) root.style.setProperty('--brand-danger', settings.btn_danger_colour);
  if (settings.print_accent_colour) root.style.setProperty('--brand-print-accent', settings.print_accent_colour);

  if (settings.font_family) {
    loadGoogleFont(settings.font_family);
    document.body.style.fontFamily = `'${settings.font_family}', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif`;
  }
}

function loadGoogleFont(fontName) {
  let link = document.getElementById(GOOGLE_FONTS_LINK_ID);
  const href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontName)}:wght@400;500;600;700;800;900&display=swap`;

  if (link) {
    if (link.getAttribute('href') !== href) {
      link.setAttribute('href', href);
    }
  } else {
    link = document.createElement('link');
    link.id = GOOGLE_FONTS_LINK_ID;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}
